module.exports = __webpack_public_path__ + "img/4-weatherpump.1da68d18.png";